module.exports = __webpack_public_path__ + "img/google-pay.db31e22e.svg";